<div class="flex-1 flex flex-col overflow-hidden">
  <app-map
    [type]="'entity'"
    class="flex-grow overflow-hidden"
    [fields]="fields"
    [isUpdateZoomLevel]="isUpdateZoomLevel"
    [clients]="clients"
    [(selectedClientId)]="clientId"
    (featureProperties)="selectUpdateModalShow($event)"
  />
</div>
<app-field-view-entity
  [id]="properties?.id"
  [properties]="properties?.claimed_details"
>
</app-field-view-entity>
